module.exports = __webpack_public_path__ + "img/xcg2.939c9bd1.jpg";